import { useEffect } from 'react';
import { Platform } from 'react-native';
import { Session } from '../../state/Session';
import { tap2PayEmbeddedManager } from '../../utils/Tap2PayEmbeddedManager';
import Sentry from '../../utils/Sentry/Sentry';

export function useTap2PayEmbeddedInit(session: Partial<Session> | undefined) {
  useEffect(() => {
    if (Platform.OS !== 'android') return;

    const enableTap2PayEmbedded =
      session?.device?.enableTap2PayEmbedded ?? false;
    const linkCdsToPayApp = session?.device?.linkCdsToPayApp ?? false;
    if (!enableTap2PayEmbedded || !linkCdsToPayApp) return;

    const storeRef = session?.currentStore?.payStoreRefs?.instore;
    const merchant = session?.currentStore?.merchantId;
    const accessToken = session?.token;

    if (!storeRef || !merchant || !accessToken) {
      Sentry.addBreadcrumb({
        category: 'tap2pay-embedded',
        message: 'Skipped init: missing storeRef/merchant/accessToken',
        level: 'warning',
        data: {
          hasStoreRef: !!storeRef,
          hasMerchant: !!merchant,
          hasAccessToken: !!accessToken,
        },
      });
      return;
    }

    const ds = session?.device?.tap2PayDisplaySettings;

    tap2PayEmbeddedManager
      .initialize({
        store: storeRef,
        merchant,
        accessToken,
        userId: '',
        terminalId: '',
      })
      .then(() => {
        if (ds) {
          tap2PayEmbeddedManager
            .setDisplaySettings({
              kioskModeEnabled: true,
              enableRotation: ds.enableRotation,
              nfcKioskPosition: ds.nfcKioskPosition,
              pinAlignment: ds.pinAlignment,
            })
            .catch(() => {});
        }
        tap2PayEmbeddedManager.warmup();
      })
      .catch((error: unknown) => {
        Sentry.captureException(error, {
          extra: {
            storeRef,
            merchant,
            context: 'tap2pay-embedded-init-cds',
          },
        });
      });
  }, [
    session?.currentStore?.payStoreRefs?.instore,
    session?.currentStore?.merchantId,
    session?.token,
    session?.device?.enableTap2PayEmbedded,
    session?.device?.linkCdsToPayApp,
    session?.device?.tap2PayDisplaySettings,
  ]);
}
